(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-richtext-more-less')) {
		customElements.define(
			'l-richtext-more-less',
			class LRichtextMoreLess extends HTMLElement {
				connectedCallback() {
					if (this._initDone) return

					this.contentEl = this.querySelector('.l-RMLess__content')
					this.btnEl = this.querySelector('.l-RMLess__toggle')

					if (!this.contentEl || !this.btnEl) return

					this._initDone = true

					this.moreLabel = this.btnEl.getAttribute('data-label-more') || 'Show more'
					this.lessLabel = this.btnEl.getAttribute('data-label-less') || 'Show less'

					this.onClick = () => {
						const expanded = this.contentEl.classList.toggle('is-expanded')
						this.btnEl.setAttribute('aria-expanded', expanded ? 'true' : 'false')
						this.btnEl.textContent = expanded ? this.lessLabel : this.moreLabel
						if (!expanded) {
							requestAnimationFrame(() => {
								this.btnEl.hidden = this.contentEl.scrollHeight <= this.contentEl.clientHeight
								this.contentEl.scrollIntoView({ block: 'center', behavior: 'smooth' })
							})
						} else {
							this.btnEl.hidden = false
						}
					}

					this.btnEl.addEventListener('click', this.onClick)

					const debounce = (fn, ms) => {
						let t
						return (...args) => {
							clearTimeout(t)
							t = setTimeout(() => fn.apply(this, args), ms)
						}
					}

					this.debouncedMeasure = debounce(() => {
						this.measure()
					}, 150)
					window.addEventListener('resize', this.debouncedMeasure)

					if (document.fonts && document.fonts.ready) {
						document.fonts.ready.then(() => {
							this.measure()
						})
					} else {
						requestAnimationFrame(() => {
							this.measure()
						})
					}
				}

				disconnectedCallback() {
					if (this.debouncedMeasure) {
						window.removeEventListener('resize', this.debouncedMeasure)
					}
					if (this.btnEl && this.onClick) {
						this.btnEl.removeEventListener('click', this.onClick)
					}
					this._initDone = false
				}

				measure() {
					if (!this.contentEl || !this.btnEl) return
					if (this.contentEl.classList.contains('is-expanded')) {
						this.btnEl.hidden = false
						return
					}
					const overflow = this.contentEl.scrollHeight > this.contentEl.clientHeight
					this.btnEl.hidden = !overflow
					this.btnEl.setAttribute('aria-expanded', 'false')
					this.btnEl.textContent = this.moreLabel
				}
			}
		)
	}

  } catch(e) { console.error(e); }
})();
})();
